import api from 'helpers/api';
import currencyFormatter from 'helpers/currency_formatter';
import dateFormatter from 'helpers/date_formatter';
import { useAngularService } from 'helpers/get_angular_service';
import sources from 'helpers/sources';
import React, { useEffect, useState } from 'react';
import Button from '../../components/button';
import { Gym } from '../../types/gym';

const DisplayAppliedCreditModal = ({ modalInstance, invoice }) => {
  const $rootScope = useAngularService('$rootScope');
  const ReactModal = useAngularService('ReactModal');
  const EmploymentService = useAngularService('EmploymentService');
  const FeatureAvailabilityService = useAngularService('FeatureAvailabilityService');

  const permissions = EmploymentService.get().permissions;
  const gym: Gym = $rootScope.gym;
  const creditVouchersAvailable = FeatureAvailabilityService.isAvailable('credit_vouchers');

  const [credits, setCredits] = useState([]);

  const cancel = () => {
    modalInstance.dismiss('cancel');
  };

  useEffect(() => {
    const url = sources.creditVoucherActivities(gym.id);
    api
      .get(url, {
        filters: {
          invoice_number: invoice.invoice_number,
          removed: false,
          category: 'credit_applied',
        },
      })
      .then((response) => {
        setCredits(response);
      });
  }, []);

  const removeCreditAvailable = () => {
    return (
      creditVouchersAvailable &&
      permissions.adjust_payment_credit &&
      ['paid', 'pending', 'submitted'].indexOf(invoice.status) === -1
    );
  };

  const removeCredit = () => {
    cancel();

    ReactModal.open({
      component: 'RemoveCreditModal',
      props: {
        invoice,
      },
    });
  };

  return (
    <div>
      <div className="modal-header">
        <a aria-hidden="true" className="close-modal" onClick={cancel} title="Close">
          <i className="icon-cross"></i>
        </a>
        <h4 className="modal-title">Credit applied to Invoice #{invoice.invoice_number_base}</h4>
      </div>
      <div className="modal-body modal-body-visible">
        <p>The following credit amount(s) have been applied to this payment:</p>

        <ul>
          {credits.map((credit) => (
            <li key={credit.id}>
              {currencyFormatter(-credit.amount, gym.currency_symbol)}, applied by{' '}
              {credit.redeemed_by_name} on {dateFormatter(credit.created_at)}
            </li>
          ))}
        </ul>

        {gym.has_payment_provider && (
          <p>
            Credit applied to a payment will reduce the amount requested from the customer's bank,
            when the payment is submitted for processing.
          </p>
        )}
      </div>

      <div className="modal-footer">
        {removeCreditAvailable() && (
          <Button variant="primary" onClick={() => removeCredit()}>
            Remove credit
          </Button>
        )}

        <Button onClick={cancel}>Close</Button>
      </div>
    </div>
  );
};

angular.module('gym').value('DisplayAppliedCreditModal', DisplayAppliedCreditModal);
